import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowUpRight"><Path fillRule="evenodd" clipRule="evenodd" d="M8.00023 5H19.0002V16H16.0002V10.1213L6.50023 19.6213L4.37891 17.5L13.8789 8H8.00023V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpRight;
